import config from "../config.js";
import VueI18n from "vue-i18n";
import translation from "./index.js";
import dateTimeFormats from "./dateTime";
const siteConfig = config[process.env.NODE_ENV];
import Vue from "vue";
const lang = localStorage.getItem('lang') || navigator.languages[0]
import store from '../store/index.js'

if (siteConfig.supportedLang.includes(lang)) {
  store.commit('LANG', lang)
} else {
  store.commit('LANG', siteConfig.defalultLang)
}

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: lang,
  messages: translation,
  dateTimeFormats,
  fallbackLocale: siteConfig.defalultLang
});

export default i18n;
